<template>
  <div class="fill-height of-y" style="overflow-x: hidden; position: relative">
    <v-progress-linear style="position: absolute; top: 0; left: 0; width: 100%" class="ma-0" indeterminate v-if="saving"></v-progress-linear>
    <transition enter-active-class="scale-in-center" leave-active-class="scale-out-center" mode="out-in">
      <div class="c-d-flex c-align-center c-justify-center fill-height" v-if="loading" key="loading">
        <v-progress-circular
            :size="40"
            :width="3"
            color="secondary"
            indeterminate
        ></v-progress-circular>
      </div>
      <div v-else key="loaded" class="fill-height of-y c-d-flex c-flex-column" style="overflow-x: hidden">
        <v-card class="ma-3 page-back" >
          <v-card-title>
            Default Models
          </v-card-title>
          <v-card-text class="px-2" v-if="!refreshEnabled">
            <div class="c-d-flex c-align-center c-justify-space-around">
              <div class="c-flex-equal c-flex-grow-1 px-2">
                <div class="caption text--disabled pb-1">Task chat:</div>
                <v-autocomplete flat hide-details solo :items="sortedModelsToolsEnabled" v-model="taskChatDefault" item-value="id" item-text="name" item>
                  <template #selection="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                  <template #item="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                </v-autocomplete>
              </div>
              
              <div class="c-flex-equal c-flex-grow-1 px-2">
                <div class="caption text--disabled pb-1">Dashboard chat:</div>
                <v-autocomplete flat hide-details solo :items="sortedModelsToolsEnabled" v-model="dashboardChatDefault" item-value="id" item-text="name">
                  <template #selection="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                  <template #item="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                </v-autocomplete>
              </div>
              <div class="c-flex-equal c-flex-grow-1 px-2">
                <div class="caption text--disabled pb-1">Mail chat:</div>
                <v-autocomplete flat hide-details solo :items="sortedModelsToolsEnabled" v-model="mailChatDefault" item-value="id" item-text="name">
                  <template #selection="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                  <template #item="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                </v-autocomplete>
              </div>
              <div class="c-flex-equal c-flex-grow-1 px-2">
                <div class="caption text--disabled pb-1">Folder chat:</div>
                <v-autocomplete flat hide-details solo :items="sortedModelsToolsEnabled" v-model="folderChatDefault" item-value="id" item-text="name">
                  <template #selection="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                  <template #item="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                </v-autocomplete>
              </div>
              <div class="c-flex-equal c-flex-grow-1 px-2">
                <div class="caption text--disabled pb-1">Workflow actions:</div>
                <v-autocomplete flat hide-details solo :items="sortedModels" v-model="workflowToolsDefault" item-value="id" item-text="name">
                  <template #selection="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                  <template #item="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                </v-autocomplete>
              </div>
              <div class="c-flex-equal c-flex-grow-1 px-2">
                <div class="caption text--disabled pb-1">Dataset actions:</div>
                <v-autocomplete flat hide-details solo :items="sortedModels" v-model="datasetToolsDefault" item-value="id" item-text="name">
                  <template #selection="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                  <template #item="{item}"><v-list-tile-avatar><v-icon>{{ item.icon }}</v-icon></v-list-tile-avatar><v-list-tile-content><v-list-tile-sub-title>{{ item.ecosystem }}</v-list-tile-sub-title><v-list-tile-title>{{ item.name }}</v-list-tile-title></v-list-tile-content></template>
                </v-autocomplete>
              </div>
            </div>
          </v-card-text>
        </v-card>
        
        <v-data-table
            :headers="headers"
            :items="modelOptions"
            item-key="modelId"
            class="fill-height scroll-table-with-foot ma-3"
            :rows-per-page-items="[{'text':'All','value':-1}, 5,10,25]"
        >
          <template v-slot:items="{item}">
            <td>
              <div class="c-d-flex py-1 c-align-center">
                <v-icon class="mr-3">{{ modelsRef[item.modelId].icon }}</v-icon>
                <div class="c-flex-grow-1">
                  <v-list-tile-sub-title>{{ modelsRef[item.modelId].ecosystem }}</v-list-tile-sub-title>
                  <v-list-tile-title>{{ modelsRef[item.modelId].name }}</v-list-tile-title>
                </div>
              </div>
            </td>
<!--            // mTokenInput-->
<!--            // mTokenOutput-->
            <td class="text-xs-right">
              {{ modelsRef[item.modelId].mTokenInput ? `R ${modelsRef[item.modelId].mTokenInput.toFixed(2)}` : '-' }}
            </td>
            <td class="text-xs-right">
              {{ modelsRef[item.modelId].mTokenOutput ? `R ${modelsRef[item.modelId].mTokenOutput.toFixed(2)}` : '-' }}
            </td>
            <td class="text-xs-center" v-for="keyStr in ['taskChatEnabled', 'dashboardChatEnabled', 'mailChatEnabled', 'folderChatEnabled', 'workflowToolsEnabled', 'datasetToolsEnabled']">
              <v-btn small icon>
                <v-btn
                    icon small flat
                    :color="!item[keyStr] ? undefined : 'secondary'"
                    class="pa-0 ma-0"
                    @click="updateModelEnabled(item, keyStr)"
                    :loading="pendingActions.includes(`${item.modelId}-${keyStr}`)"
                    :disabled="pendingActions.includes(`${item.modelId}-${keyStr}`)"
                >
                  <v-icon>{{ item[keyStr] ? 'check_box' : 'check_box_outline_blank'}}</v-icon>
                </v-btn>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
    </transition>
  </div>
</template>

<script>
import {validationRules} from "@/codeFunctions";
import format from "date-fns/format";

export default {
  props: {
    propName: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      loading: true,
      saving: false,
      modelInfo: [],
      modelOptions: [],
      headers: [
        {text: 'Model', align: 'left', value: 'fullName'},
        {text: 'Input Per M Tok', value: 'mTokenInput', align: 'right'},
        {text: 'Output Per M Tok', value: 'mTokenOutput', align: 'right'},
        {text: 'Task chat', value: 'taskChatEnabled', align: 'center', sortable: false},
        {text: 'Dashboard chat', value: 'dashboardChatEnabled', align: 'center', sortable: false},
        {text: 'Mail chat', value: 'mailChatEnabled', align: 'center', sortable: false},
        {text: 'Folder chat', value: 'folderChatEnabled', align: 'center', sortable: false},
        {text: 'Workflow Tools', value: 'workflowToolsEnabled', align: 'center', sortable: false},
        {text: 'Dataset Tools', value: 'datasetToolsEnabled', align: 'center', sortable: false},
      ],
      pendingActions: [],
      refreshEnabled: false
    }
  },
  mounted() {
    this.loading = true
    this.startup()
        .finally(() => {
          this.loading = false
        })
  },
  watch: {
    saving(val) {
      if (!val) {
        // this.refreshEnabled = true
        // this.set(() => this.refreshEnabled = false)
      }
    }
  },
  methods: {
    format,
    
    async startup() {
      try {
        this.saving = true
        const { modelInfo, modelOptions } = await this.$newReq('GET', `ai/admin/models/startup`)
        this.modelInfo = modelInfo.map(v => ({
          ...v,
          icon: v.isToolsEnabled ? 'handyman' : 'try',
          fullName: v.ecosystem + ' - ' + v.name,
        }))
        this.modelOptions = modelOptions
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.saving = false
      }
    },
    
    async updateModelEnabled(model, key) {
      try {
        
        const modelDefaultMap = {
          taskChatEnabled: 'taskChatDefault',
          dashboardChatEnabled: 'dashboardChatDefault',
          mailChatEnabled: 'mailChatDefault',
          folderChatEnabled: 'folderChatDefault',
          workflowToolsEnabled: 'workflowToolsDefault',
          datasetToolsEnabled: 'datasetToolsDefault'
        }
        
        const modelUpdate = {modelId: model.modelId}
        const newValue = !model[key]
        modelUpdate[key] = newValue
        if (!newValue)
          modelUpdate[modelDefaultMap[key]] = false
        
        this.pendingActions.push(`${model.modelId}-${key}`)
        
        await this.$newReq('POST', `ai/admin/models/upsert`, modelUpdate)
        this.startup()
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        await this.startup()
        this.saving = false
        this.pendingActions = this.pendingActions.filter(v => v !== `${model.modelId}-${key}`)
      }
    },
    
    async setDefaultModel(key, modelId) {
      try {
        this.saving = true
        
        const modelDefaultMap = {
          taskChatDefault: 'taskChatEnabled',
          dashboardChatDefault: 'dashboardChatEnabled',
          mailChatDefault: 'mailChatEnabled',
          folderChatDefault: 'folderChatEnabled',
          workflowToolsDefault: 'workflowToolsEnabled',
          datasetToolsDefault: 'datasetToolsEnabled'
        }
        
        await this.$newReq('POST', `ai/admin/models/setDefault`, {
          modelId,
          defaultKey: key,
          enabledKey: modelDefaultMap[key] || undefined
        })
        
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        await this.startup()
        this.saving = false
      }
    }
    
    
  },
  computed: {
    validationRules() {
      return validationRules
    },
    
    sortedModels() {
      return this.modelInfo.sort((a, b) => {
        if (a.ecosystem === b.ecosystem) return a.name.localeCompare(b.name)
        return a.ecosystem.localeCompare(b.name)
      })
    },
    modelsRef() {
      return this.sortedModels.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    },
    
    sortedModelsToolsEnabled() {
      return this.sortedModels.filter(v => v.isToolsEnabled)
    },
    
    taskChatDefault: {
      get() {
        return this.modelOptions.find(m => m.taskChatDefault)?.modelId || null
      },
      set(val) {
        this.setDefaultModel('taskChatDefault', val)
      }
    },
    dashboardChatDefault: {
      get() {
        return this.modelOptions.find(m => m.dashboardChatDefault)?.modelId || null
      },
      set(val) {
        this.setDefaultModel('dashboardChatDefault', val)
      }
    },
    mailChatDefault: {
      get() {
        return this.modelOptions.find(m => m.mailChatDefault)?.modelId || null
      },
      set(val) {
        this.setDefaultModel('mailChatDefault', val)
      }
    },
    folderChatDefault: {
      get() {
        return this.modelOptions.find(m => m.folderChatDefault)?.modelId || null
      },
      set(val) {
        this.setDefaultModel('folderChatDefault', val)
      }
    },
    workflowToolsDefault: {
      get() {
        return this.modelOptions.find(m => m.workflowToolsDefault)?.modelId || null
      },
      set(val) {
        this.setDefaultModel('workflowToolsDefault', val)
      }
    },
    datasetToolsDefault: {
      get() {
        return this.modelOptions.find(m => m.datasetToolsDefault)?.modelId || null
      },
      set(val) {
        this.setDefaultModel('datasetToolsDefault', val)
      }
    },
  },
}
</script>


<style scoped>

</style>